import { useScoreStore } from '~/stores/score'

import { isCardKnown, isCardSnoozedBySwipe, isCardWithinLimit, isVerticalSwipeDominant } from '../../utils/card'

import { DRAG_ROTATION_FACTOR, EXIT_OFFSET_X, EXIT_OFFSET_Y, EXIT_ROTATION_DEGREES } from './const'

export const updateScoreFromSwipeDelta = (deltaX: number, deltaY: number) => {
  const { setIsGuessedActive, setIsNotGuessedActive, setIsSnoozeActive } = useScoreStore.getState()

  if (isVerticalSwipeDominant(deltaX, deltaY)) {
    const isSnoozed = isCardSnoozedBySwipe(deltaX, deltaY)
    setIsSnoozeActive(isSnoozed)
    setIsGuessedActive(isSnoozed)
    setIsNotGuessedActive(false)

    return
  }

  if (isCardWithinLimit(deltaX)) {
    setIsSnoozeActive(false)
    setIsGuessedActive(false)
    setIsNotGuessedActive(false)

    return
  }

  if (isCardKnown(deltaX)) {
    setIsSnoozeActive(false)
    setIsGuessedActive(true)
    setIsNotGuessedActive(false)

    return
  }

  setIsSnoozeActive(false)
  setIsNotGuessedActive(true)
  setIsGuessedActive(false)
}

export const getExitTargets = (deltaX: number, deltaY: number) => {
  const isGuessed = isCardSnoozedBySwipe(deltaX, deltaY) || isCardKnown(deltaX)

  return {
    x: deltaX + (isGuessed ? EXIT_OFFSET_X : -EXIT_OFFSET_X),
    y: deltaY + EXIT_OFFSET_Y,
    rotate: isGuessed ? EXIT_ROTATION_DEGREES : -EXIT_ROTATION_DEGREES,
  }
}

export const getDragRotationDegrees = (deltaX: number) => deltaX * DRAG_ROTATION_FACTOR
